import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const discussionForumComponentMapping = {
  eventDiscussionForumLoader: defineAsyncComponent(() => importWithRetry(() => import('@/events/discussion-forum-loader'))),
  groupDiscussionForumContainer: defineAsyncComponent(() => importWithRetry(() => import('./local-chapters/discussion-forum-container')))
}

const discussionForumThreadComponentMapping = {
  groupDiscussionForumThreadContainer: defineAsyncComponent(() => importWithRetry(() => import('./local-chapters/discussion-forum-thread-container')))
}

addComponentLoader(discussionForumComponentMapping, {}, () => importWithRetry(() => import('./common/store/forum')))
addComponentLoader(discussionForumThreadComponentMapping, {}, () => importWithRetry(() => import('./common/store/thread')))
